import { noop } from 'lodash/fp';
import { SearchResult } from '@mews-commander/types';
import { SEARCH_TYPE_ICON_MAP } from './constants';

interface Params {
    searchResult?: SearchResult | null;
    handler(url: string): void;
}

const EMPTY_CAPTION = {
    interactiveIcon: undefined,
    interactiveIconHandler: noop,
};

export const getSearchResultInteractiveDetail = ({ searchResult, handler }: Params) => {
    if (!searchResult) {
        return EMPTY_CAPTION;
    }

    const { searchType, url } = searchResult;
    const icon = SEARCH_TYPE_ICON_MAP[searchType];

    if (!icon || !url) {
        return EMPTY_CAPTION;
    }

    return {
        interactiveIcon: icon,
        interactiveIconHandler: () => handler(url),
    };
};
